<template>
  <floating-element
    name="transition-from-left-corner"
    class="documentation__overlay"
    @pointerdown:outside="close"
  >
    <input-texteditor
      ref="inputElement"
      :value="value"
      :editor="true"
      placeholder="Dokumentation"
      @update:value="$emit('update:value', $event)"
    />
  </floating-element>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

import InputTexteditor from "@core/input/TextEditor.vue";
import FloatingElement from "@core/ui/FloatingElement.vue";

withDefaults(
  defineProps<{
    value?: string;
  }>(),
  {
    value: ""
  }
);
const emit = defineEmits<{
  (e: "update:value", value: string): void;
  (e: "hide"): void;
}>();

const inputElement = ref<InstanceType<typeof InputTexteditor>>();

onMounted(() => {
  inputElement.value?.focus();
});

function close(mouseEvent: MouseEvent) {
  const path = mouseEvent.composedPath();

  const pathClasses = path.flatMap((element: EventTarget | HTMLElement) => [
    ...("classList" in element ? element.classList : [])
  ]);

  // prevent closing when in the expanded text editor
  if (
    pathClasses.includes("textviewer") ||
    pathClasses.includes("tool-tip") ||
    pathClasses.includes("floating-element__backdrop")
  ) {
    return;
  }

  emit("hide");
}
</script>

<style lang="scss">
.documentation {
  &__overlay {
    width: 20rem;
    min-height: 5rem;
  }
}
</style>
